import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Collapse, Paper, Button, TextField, Dialog,
  DialogTitle, DialogActions, Typography, IconButton,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Box
} from "@mui/material";
import { Edit, Delete, ArrowBack, Save, Cancel, CallSplit } from "@mui/icons-material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Grid from '@mui/material/Grid2';
import axios from 'axios';
import { ConcepteIcon, TipusMovIcon } from './IconMap.js';
import { strDateToDDMMYYYY, strDateToYYYYMMDD } from '../../functions/formatDate.js';
import { formatEuro } from '../../functions/formatNumber.js';
import AppContext from '../AppContext.js';
import { getColorForAmount } from '../../functions/colors.js';
import config from '../../config.js';
import { SelectConcepteTextField } from './SelectConcepte.js';
import useBack from '../../hooks/useBack.js';
import { formatSmartConceptPath, buildFullTreeWithEntities } from '../../services/concepteGraphService.js';
import ConcepteMovementDisplay from './ConcepteMovementDisplay.js';


const DetallConcepteMovimentComponent = ({ data, userapp, concMovId, listConceptes, onError, onSave }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editData, setEditData] = useState({ ...data });
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [openMasInfo, setOpenMasInfo] = useState(true); // Estado para controlar el colapso
    const [movimentDetall, setMovimentDetall] = useState(null);

    const { ctxUser, ctxApp, setCtxApp, conceptesList, conceptesTree, entitatsTransversals, conceptesNodesMap } = useContext(AppContext);
    const jwtToken = ctxUser?.fdvToken?.jwtToken || '';

    const targetConceptList = listConceptes || conceptesList;
    const conceptObj = targetConceptList?.find(c => c.nom === editData.concepte);
    const isInvestment = conceptObj?.tipus === 'INVERSIO';
    const colorImport = getColorForAmount(editData.importe, isInvestment);

    const targetNodeId = (typeof editData.nodeFulla === 'number' ? editData.nodeFulla : editData.nodeFulla?.id) ||
        (typeof data.nodeFulla === 'number' ? data.nodeFulla : data.nodeFulla?.id) ||
        editData.id_node_fulla || data.id_node_fulla || data.idNodeFulla;
    const catalogNode = (targetNodeId && conceptesNodesMap) ? conceptesNodesMap.get(Number(targetNodeId)) : null;

    const targetNodeInfo = {
        id: targetNodeId,
        conceptePath: editData.conceptePath || data.conceptePath || (typeof editData.nodeFulla === 'object' ? editData.nodeFulla?.conceptePath : null) || (typeof data.nodeFulla === 'object' ? data.nodeFulla?.conceptePath : null) || catalogNode?.conceptePath,
        concepteClassic: editData.concepte || data.concepte,
        nom: (typeof editData.nodeFulla === 'object' ? editData.nodeFulla?.nom : null) || (typeof data.nodeFulla === 'object' ? data.nodeFulla?.nom : null) || catalogNode?.nom
    };
    const enrichedTree = buildFullTreeWithEntities(conceptesTree, entitatsTransversals);
    const { fullBreadcrumb } = formatSmartConceptPath(editData.concepte, targetNodeInfo, enrichedTree);
    const hierarchicalPath = fullBreadcrumb || editData.nodeFulla?.pathLabel || '';

    const navigate = useNavigate();

    const { onBack } = useBack();

    const handleNavigate = (to, params={}) => {
        //console.log('Intenta redirigir a:', to);
        navigate(to, params);
    };

    const handleCancelEdit = () => {
        setIsEditing(false);
        setEditData({ ...data });
    };

    const handleEditToggle = () => setIsEditing(!isEditing);
    const handleDeleteConfirm = () => setShowDeleteConfirm(true);
    const handleSubdivide = () => {
        handleNavigate(`/${userapp}/subdivide/${concMovId}`);
    };

    const updateNumPendentTotal = () => {
        axios.get(`${config.apiBaseUrl}/v1/numtractamentmanual/${userapp}`,
        { headers: { Authorization: `${jwtToken}` } }
        ).then((response) => {
        const newCtxData = {
            ...ctxApp,
            numConceptePendent: response.data?.numConceptePendent || 0,
            numDesglosPendent: response.data?.numDesglosPendent || 0,
            numPendentValidar: response.data?.numPendentValidar || 0,
            numPendentTotal: (response.data?.numConceptePendent || 0) + (response.data?.numDesglosPendent || 0) + (response.data?.numPendentValidar || 0)
        };
        setCtxApp(newCtxData);
        }).catch((err) => {
        onError(err, 'update num pendents');
        });
    };

    const handleSave = () => {
        const toNodeRef = (val) => {
            if (!val) return null;
            const id = typeof val === 'object' ? val.id : val;
            return id ? { id: Number(id) } : null;
        };

        const isHierarchyNode = Boolean(
            editData.nodeFulla || editData.idNodeFulla || editData.id_node_fulla || editData.nodeN1 || editData.idNodeN1
        );

        const payload = {
            ...editData,
            concepte: isHierarchyNode ? null : (editData.concepte || null),
            nodeN1: toNodeRef(editData.nodeN1 || editData.idNodeN1 || editData.id_node_n1),
            nodeN2: toNodeRef(editData.nodeN2 || editData.idNodeN2 || editData.id_node_n2),
            nodeN3: toNodeRef(editData.nodeN3 || editData.idNodeN3 || editData.id_node_n3),
            nodeFulla: toNodeRef(editData.nodeFulla || editData.idNodeFulla || editData.id_node_fulla),
        };
        axios.put(`${config.apiBaseUrl}/v1/concmovs/${concMovId}`,
        payload,
        { headers: { Authorization: `${jwtToken}` } }
        ).then((response) => {
        setIsEditing(false);
        updateNumPendentTotal();
        if (response.data) {
            setEditData({ ...response.data });
        }
        if (onSave) onSave(response.data || editData);
        }).catch((err) => {
        onError(err, 'guardar');
        });
    };



    const doDelete = () => {
        axios.delete(`${config.apiBaseUrl}/v1/concmovs/${concMovId}`,
        { headers: { Authorization: `${jwtToken}` } }
        ).then(() => {
        setShowDeleteConfirm(false);
        updateNumPendentTotal();
        onBack();
        }).catch((err) => {
        onError(err, 'borrar');
        });
    };

    const handleToggleMasInfo = () => {
        setOpenMasInfo(!openMasInfo); // Alterna entre colapsado y expandido
    };

    useEffect(() => {
        //console.log('Detall Moviment useEffect:', data);
        setEditData({...data});
    }, [data]);

    useEffect(() => {
        if (data && data.moviment && data.moviment.id) {
            axios.get(`${config.apiBaseUrl}/v1/moviment/${data.moviment.id}`, {
                headers: { Authorization: `${jwtToken}` }
            })
            .then(res => {
                setMovimentDetall(res.data);
            })
            .catch(err => {
                onError(err, 'cargar detalles del movimiento');
            });
        }
    }, [data, jwtToken, onError]);

    return (
        <Grid container spacing={2} padding={2} >
        <Grid size={12} display="flex" justifyContent="space-between" alignItems="center">
            <Grid display="flex" alignItems="center">
            <IconButton onClick={onBack}>
                <ArrowBack />
            </IconButton>
            <Typography variant="h5">Detall Concepte Moviment</Typography>
            {/*
            <IconButton onClick={()=>handleNavigate('/PISMANRESA/cmovdetail/55606', { replace: true })}>
                <ArrowBack />
            </IconButton>          
            */}
            </Grid>

            {/* Botones de acción */}
            <Grid display="flex" justifyContent="flex-end">
            {isEditing ? (
                <>
                <IconButton onClick={handleSave}><Save /></IconButton>
                <IconButton onClick={handleCancelEdit}><Cancel /></IconButton>
                </>
            ) : (
                <>
                <IconButton onClick={handleEditToggle}><Edit /></IconButton>
                <IconButton onClick={handleDeleteConfirm}><Delete /></IconButton>
                <IconButton onClick={handleSubdivide}><CallSplit /></IconButton>
                </>
            )}
            </Grid>
        </Grid>

        <Grid >
            <Paper sx={{ padding: '16px', mb: 2 }}>
            <Grid container spacing={1}>
                <Grid size={6}>
                <Typography variant="body1"><strong>ID:</strong> {editData.id}</Typography>
                </Grid>
                <Grid size={6}>
                <Typography variant="body1"><strong>Id Moviment:</strong> {editData.moviment.id}</Typography>
                </Grid>
                <Grid size={6}>
                <Typography>
                    <strong>Tipus:</strong>
                    <TipusMovIcon tipus={editData.moviment.tipus} />
                </Typography>
                </Grid>
                <Grid size={6}><Typography><strong>Data original:</strong> {strDateToDDMMYYYY(editData.moviment.dataOrig)}</Typography></Grid>
                <Grid size={6}><Typography><strong>Moviment:</strong> {editData.moviment.moviment}</Typography></Grid>
                <Grid size={6}><Typography><strong>Importe Original:</strong> {formatEuro(editData.moviment.importOrig)}</Typography></Grid>
            </Grid>
            </Paper>

            <Paper sx={{ padding: '16px', mb: 2 }}>
            <Grid container spacing={1}>

                <Grid size={6}>
                {isEditing ? (
                    <SelectConcepteTextField
                    label="Concepte"
                    value={
                      editData.conceptePath ||
                      (editData.id_node_fulla ? `node:${editData.id_node_fulla}` : null) ||
                      (typeof editData.nodeFulla === 'number' ? `node:${editData.nodeFulla}` : null) ||
                      (editData.nodeFulla?.id ? `node:${editData.nodeFulla.id}` : null) ||
                      editData.concepte
                    }
                    onChange={(e, selectedNode) => {
                      const node = selectedNode || e.target?.node;
                      if (node) {
                        const isN3 = Boolean(node.nodeN3);
                        setEditData(prev => ({
                          ...prev,
                          concepte: null, // El concepte clàssic el resol oficialment el backend
                          nodeFulla: node,
                          id_node_fulla: node.id,
                          idNodeFulla: node.id,
                          conceptePath: node.conceptePath,
                          nodeN1: node.nodeN1 || null,
                          nodeN2: node.nodeN2 || null,
                          nodeN3: isN3 ? (node.nodeN3 || null) : null,
                          id_node_n1: node.nodeN1?.id || null,
                          id_node_n2: node.nodeN2?.id || null,
                          id_node_n3: isN3 ? (node.nodeN3?.id || null) : null,
                          idNodeN1: node.nodeN1?.id || null,
                          idNodeN2: node.nodeN2?.id || null,
                          idNodeN3: isN3 ? (node.nodeN3?.id || null) : null,
                        }));
                      } else {
                        setEditData(prev => ({
                          ...prev,
                          concepte: e.target?.value || '',
                          nodeFulla: null,
                          id_node_fulla: null,
                          idNodeFulla: null,
                          conceptePath: null,
                          nodeN1: null,
                          nodeN2: null,
                          nodeN3: null,
                          id_node_n1: null,
                          id_node_n2: null,
                          id_node_n3: null,
                          idNodeN1: null,
                          idNodeN2: null,
                          idNodeN3: null,
                        }));
                      }
                    }}
                    listConceptes={listConceptes}
                    />
                    ) : (
                    <Grid sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <Typography variant="body1"><strong>Concepte:</strong></Typography>
                        <ConcepteIcon concept={editData.concepte} />
                      </Box>
                      {hierarchicalPath && (
                        <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.75rem' }}>
                          <strong>Ruta Jeràrquica:</strong> {hierarchicalPath}
                        </Typography>
                      )}
                    </Grid>
                )}
                </Grid>

                <Grid size={6}>
                {isEditing ? (
                    <TextField
                    fullWidth
                    label="Import Moviment"
                    type="number"
                    value={editData.importe}
                    onChange={(e) => setEditData({ ...editData, importe: parseFloat(e.target.value) })}
                    />
                ) : (
                    <Typography><strong>Import Moviment:</strong> <span style={{ color: colorImport, fontWeight: 'bold' }}>{formatEuro(editData.importe)}</span></Typography>
                )}
                </Grid>

                <Grid size={6}>
                {isEditing ? (
                    <TextField
                    fullWidth
                    label="Data Moviment"
                    type="date"
                    value={strDateToYYYYMMDD(editData.data)}
                    onChange={(e) => setEditData({ ...editData, data: e.target.value })}
                    />
                ) : (
                    <Typography><strong>Data Moviment:</strong> {strDateToDDMMYYYY(editData.data)}</Typography>
                )}
                </Grid>

                <Grid size={6}>
                {isEditing ? (
                    <TextField
                    fullWidth
                    label="Descripció"
                    value={editData.descripcio}
                    onChange={(e) => setEditData({ ...editData, descripcio: e.target.value })}
                    />
                ) : (
                    <Typography><strong>Descripció:</strong> {editData.descripcio ? editData.descripcio : 'N/D'}</Typography>
                )}
                </Grid>
            </Grid>
            </Paper>

            <Paper sx={{ padding: '16px', mb: 2 }}>
            <Grid container alignItems="center" justifyContent="space-between" onClick={handleToggleMasInfo}>
                <Typography variant="h6">+Info</Typography>
                <IconButton aria-label="expand">
                {openMasInfo ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Grid>

            <Collapse in={openMasInfo}>
                <Grid container spacing={1}>
                <Grid size={6}><Typography><strong>Compte:</strong> {editData.moviment.pantallaOrigenDades}</Typography></Grid>
                <Grid size={6}><Typography><strong>Entitat:</strong> {editData.moviment.entitatOrigen}</Typography></Grid>
                <Grid size={6}><Typography><strong>Contracte:</strong> {editData.moviment.contracte}</Typography></Grid>
                <Grid size={6}><Typography><strong>Estat registre:</strong> {editData.moviment.estat}</Typography></Grid>
                <Grid size={6}><Typography><strong>Data Valor:</strong> {strDateToDDMMYYYY(editData.moviment.dataValor)}</Typography></Grid>
                <Grid size={6}><Typography><strong>Saldo:</strong> {formatEuro(editData.moviment.saldo)}</Typography></Grid>
                <Grid size={6}><Typography><strong>Info:</strong> {editData.moviment.mesInfo ? editData.moviment.mesInfo : 'N/D'}</Typography></Grid>
                <Grid size={6}><Typography><strong>+Info:</strong> {editData.moviment.mesInfoDetall ? editData.moviment.mesInfoDetall : 'N/D'}</Typography></Grid>
                <Grid size={6}><Typography><strong>Data Registre Mov:</strong> {strDateToDDMMYYYY(editData.moviment.itimestamp)}</Typography></Grid>
                <Grid size={6}><Typography><strong>Data Registre:</strong> {strDateToDDMMYYYY(editData.itimestamp)}</Typography></Grid>
                </Grid>
            </Collapse>
            </Paper>

            {/* Tabla de Otras Subdivisiones del Movimiento */}
            {(() => {
                if (!movimentDetall || !movimentDetall.conceptes) return null;
                const otherSubdivisions = movimentDetall.conceptes.filter(c => c.id !== editData.id);
                if (otherSubdivisions.length === 0) return null;

                return (
                    <Paper sx={{ padding: '16px', mb: 2 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                            Altres Subdivisions del Moviment
                        </Typography>
                        <TableContainer>
                            <Table stickyHeader size="small">
                                <TableHead>
                                    <TableRow sx={{
                                        borderBottom: '2px solid #ddd',
                                        '& th': {
                                            backgroundColor: '#f0f0f0',
                                            fontWeight: 'bold',
                                            color: '#000',
                                            borderBottom: 'none'
                                        }
                                    }}>
                                        <TableCell>Data</TableCell>
                                        <TableCell>Concepte</TableCell>
                                        <TableCell>Descripció</TableCell>
                                        <TableCell align="right">Import</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {otherSubdivisions.map((sub) => {
                                        const subConceptObj = targetConceptList?.find(c => c.nom === sub.concepte);
                                        const isSubInvestment = subConceptObj?.tipus === 'INVERSIO';
                                        const colorSubImport = getColorForAmount(sub.importe, isSubInvestment);

                                        return (
                                            <TableRow
                                                hover
                                                key={sub.id}
                                                onClick={() => handleNavigate(`/${userapp}/cmovdetail/${sub.id}`, { replace: false })}
                                                sx={{ cursor: 'pointer' }}
                                            >
                                                <TableCell>{strDateToDDMMYYYY(sub.data)}</TableCell>
                                                <TableCell>
                                                    <ConcepteMovementDisplay movement={sub} enrichedTree={enrichedTree} maxWidth="240px" />
                                                </TableCell>
                                                <TableCell>{sub.descripcio || 'N/D'}</TableCell>
                                                <TableCell align="right" sx={{ color: colorSubImport, fontWeight: 'bold' }}>
                                                    {formatEuro(sub.importe)}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                );
            })()}

        </Grid>

        {/* Diálogo de Confirmación de Eliminación */}
        <Dialog open={showDeleteConfirm} onClose={() => setShowDeleteConfirm(false)}>
            <DialogTitle>Confirmar Eliminació</DialogTitle>
            <DialogActions>
            <Button onClick={() => setShowDeleteConfirm(false)}>Cancel·lar</Button>
            <Button onClick={() => { doDelete() }}>Eliminar</Button>
            </DialogActions>
        </Dialog>


        </Grid>
    );
};

export default DetallConcepteMovimentComponent;